export const validationEmail = (str: string) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return emailRegex.test(str);
};

export const isNonEmptyString = (str?: string) => /^\S/.test(str || "");

export const isValidCode = (values: string[], len: number) =>
  values.length === len && values.every((val) => isNonEmptyString(val));
